// extracted by mini-css-extract-plugin
export default {"container":"money_container__feE8j","currencyUnit":"money_currencyUnit__5KE+e","disabled":"money_disabled__AXtiC","textbox":"money_textbox__H8piC"};